export const ru = {
    'add-clients-success': 'Список клиентов успешно обновлен для пакета {name}',
    'change-status-error': 'Ошибка изменения статуса пакета {name}',
    'change-status-success': 'Изменился статус пакета {name}'
};
